import type { ComponentDocs } from '@ui/components/helpers';

export const icTopBarDocs: ComponentDocs = {
  selector: 'ic-top-bar',
  status: 'adopted',
  source: 'others',
  scope: 'app',
  family: 'layout',

  outputs: [
    {
      name: 'toggle',
      payload: 'void',
      description:
        'Emite al pulsar el botón de menú. El consumidor decide el efecto: en el shell alterna la navegación en pantalla pequeña y su apariencia en grande',
    },
  ],

  directives: [],

  services: [],

  cssTokens: [
    { name: '--ic-top-bar-height', default: '32px', description: 'Alto de la barra' },
    { name: '--ic-top-bar-margin', default: '24px', description: 'Margen exterior de la barra respecto al marco que la contiene' },
  ],

  subcomponents: [],

  internals: [
    { selector: 'ic-top-bar-notification', folder: '_top-bar-notification' },
    { selector: 'ic-top-bar-user-session', folder: '_top-bar-user-session' },
  ],

  externalDeps: ['NotificationsService', 'UserService', 'NavigationService'],

  demos: [
    {
      slug: 'default',
      label: 'Default',
      loader: () =>
        import('app/modules/admin/examples/demos/others/top-bar/demos/default/demo-top-bar--default.component')
          .then(m => m.DemoTopBarDefaultComponent),
    },
  ],
};
